import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "qualitaTaskTd" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = { class: "qualitaTaskTd" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = {
    key: 0,
    class: "d-flex align-items-center mt-1"
};
const _hoisted_6 = {
    key: 1,
    class: "d-flex align-items-center mt-1"
};
const _hoisted_7 = ["readonly"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_toggler = _resolveComponent("toggler");
    return (_openBlock(), _createElementBlock("table", {
        class: _normalizeClass(["table table-fixed", { glow: _ctx.newStato == 'In modifica' }])
    }, [
        _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreArchitetto,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((_ctx.task.qualitaTask.erroreArchitetto) = $event)),
                                _cache[1] || (_cache[1] = ($event) => (_ctx.task.qualitaTask.erroreCliente = false))
                            ]
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Errore architetto", -1))
                    ])
                ]),
                _createElementVNode("td", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreCliente,
                            "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event) => ((_ctx.task.qualitaTask.erroreCliente) = $event)),
                                _cache[3] || (_cache[3] = ($event) => (_ctx.task.qualitaTask.erroreArchitetto = false))
                            ]
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Errore cliente", -1))
                    ]),
                    (_ctx.task.qualitaTask.erroreCliente)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_toggler, {
                                class: "mr-1",
                                disabled: _ctx.newStato != 'In modifica',
                                modelValue: _ctx.task.qualitaTask.hasExtraCompenso,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.task.qualitaTask.hasExtraCompenso) = $event))
                            }, null, 8, ["disabled", "modelValue"]),
                            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Extra compenso", -1))
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.task.qualitaTask.hasExtraCompenso)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Importo extra compenso", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                readonly: _ctx.newStato != 'In modifica',
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.task.qualitaTask.extraCompensoAmount) = $event))
                            }, null, 8, _hoisted_7), [
                                [_vModelText, _ctx.task.qualitaTask.extraCompensoAmount]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ], 2));
}
